import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import SendIcon from '@mui/icons-material/Send';
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { API_URL } from '../../Constants';

let apiUrl = API_URL;



const PrettoSlider = styled(Slider)({
    color: '#52af77',
    height: 8,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 40,
        height: 40,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#52af77',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
});



function QuotaSimulator() {
    const [clientName, setClientName] = useState('');
    const [monthlyCapability, setMonthlyCapability] = useState(0);
    const [creditValue, setCreditValue] = React.useState(3500000);
    const [quotasQuantity, setQuotasQuantity] = React.useState(18);
    const [quotaValue, setQuotaValue] = React.useState(0);
    const [minQuotas, setMinQuotas] = React.useState(2);

    useEffect(() => {
        if (localStorage.getItem('clientUuid') == null) {
            window.location = '/request-status';
        }

        fetch(apiUrl + '/v1/clients/' + localStorage.getItem('clientUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setClientName(res.name + ' ' + res.lastName);
                })
            } else {
                alert("Viability Not Found for clientUuid" + localStorage.getItem('clientUuid'));
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });

        fetch(apiUrl + '/v1/viability-studies/client/' + localStorage.getItem('clientUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setMonthlyCapability(res.monthlyCapability)
                })
            } else {
                alert("Viability Not Found for clientUuid" + localStorage.getItem('clientUuid'));
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });
        calculateQuotaValue(18);

    }, [])

    function calculateQuotaValue() {

        setQuotaValue((-1) * PMT(1.93/100, quotasQuantity, creditValue,0,0));
    }

    function PMT(ir, np, pv, fv, type) {
        /*
         * ir   - interest rate per month
         * np   - number of periods (months)
         * pv   - present value
         * fv   - future value
         * type - when the payments are due:
         *        0: end of the period, e.g. end of month (default)
         *        1: beginning of period
         */
        var pmt, pvif;
    
        fv || (fv = 0);
        type || (type = 0);
    
        if (ir === 0)
            return -(pv + fv)/np;
    
        pvif = Math.pow(1 + ir, np);
        pmt = - ir * (pv * pvif + fv) / (pvif - 1);
    
        if (type === 1)
            pmt /= (1 + ir);
    
        return pmt;
    }



    const handleQuotaSelected = () => {
        if(quotaValue <= monthlyCapability){
            createCredit();
            alert("Su credito ha sido creado!")
        }else{
            alert("sorry no puedes pagar esto");
        }
        console.log(monthlyCapability)
        
    }

    function createCredit(){
        let creditRequest = {
            totalValue: creditValue, quotaValue: quotaValue, clientUuid: localStorage.getItem('clientUuid'), commerceUuid:localStorage.getItem('commerceUuid'), quotasNumber: quotasQuantity
        }
        fetch(apiUrl + '/v1/credits', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(creditRequest),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    console.log(res);
                });
            }
        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    }

    const creditMarks = [
        {
            value: 1000000,
            label: "1'000.000",
        },
        {
            value: 3500000,
            label: "3'500.000",
        },
        {
            value: 6000000,
            label: "6'000.000",
        },
    ];

    const quotasMarks = [
        {
            value: 2,
            label: "2",
        },
        {
            value: 4,
            label: "4",
        },
        ,
        {
            value: 6,
            label: "6",
        },
        ,
        {
            value: 8,
            label: "8",
        },
        {
            value: 10,
            label: "10",
        },
        ,
        {
            value: 12,
            label: "12",
        },
        {
            value: 14,
            label: "14",
        },
        {
            value: 16,
            label: "16",
        },
        {
            value: 18,
            label: "18",
        }
    ];

    

    const handleChangeCreditValue = (event, newValue) => {
        if (typeof newValue === 'number') {
            setCreditValue(newValue);
        }
        calculateQuotaValue();
    };

    const handleChangeQuotasQuantity = (event, newValue) => {
        if (typeof newValue === 'number') {
            setQuotasQuantity(newValue);
        }
        calculateQuotaValue();
    };


    return (
        <React.Fragment>
            <CssBaseline />
            <Container maxWidth="md">
                <br />
                <h1>Simular cuotas para {clientName}!</h1>
                <br />
                <Box sx={{ width: 320 }}>
                    <Box sx={{ m: 3 }} />
                    <Typography gutterBottom>
                        Valor de credito: {creditValue}
                    </Typography>
                    <br />
                    <PrettoSlider
                        valueLabelDisplay="off"
                        aria-label="pretto slider"
                        defaultValue={3500000}
                        marks={creditMarks}
                        step={100000}
                        min={1000000}
                        max={6000000}
                        onChange={handleChangeCreditValue}
                    />
                </Box>
                <br />
                <br />
                <Box sx={{ width: 320 }}>
                    <Box sx={{ m: 3 }} />
                    <Typography gutterBottom>Numero de Cuotas </Typography>
                    <br />
                    <br />
                    <PrettoSlider
                        id='creditValue'
                        valueLabelDisplay="on"
                        aria-label="pretto slider"
                        defaultValue={18}
                        marks={quotasMarks}
                        min={minQuotas}
                        max={18}
                        onChange={handleChangeQuotasQuantity}
                    />
                </Box>
                <br />
                <h2>{quotasQuantity} cuotas de: {quotaValue}</h2>
                <br />
                <Stack direction="row" spacing={2}>
                    <Button variant="contained" endIcon={<SendIcon />} onClick={handleQuotaSelected} className='button'>
                        Seleccionar Cuota
                    </Button>
                </Stack>
                

            </Container>
        </React.Fragment>

    );
}

export default QuotaSimulator;